import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [astrologer, setAstrologer] = useState(null);
  const [onboardingComplete, setOnboardingComplete] = useState(false);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("jk_token");
    if (!token) {
      setAstrologer(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setAstrologer(data.astrologer);
      setOnboardingComplete(data.onboarding_complete);
    } catch {
      localStorage.removeItem("jk_token");
      setAstrologer(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = (token, astro, complete) => {
    localStorage.setItem("jk_token", token);
    setAstrologer(astro);
    setOnboardingComplete(complete);
  };

  const logout = () => {
    localStorage.removeItem("jk_token");
    setAstrologer(null);
    setOnboardingComplete(false);
  };

  return (
    <AuthContext.Provider
      value={{ astrologer, setAstrologer, onboardingComplete, setOnboardingComplete, loading, login, logout, refresh }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
